import api from "./api";


export const fetchLatestTestResults = async (userId) => {
  try {
    const response = await api.get(`/results/latest-results/${userId}`, {requiresAuth: true});
    return response.data;
  } catch (error) {
    console.error('Error fetching latest test results:', error);
    throw error;
  }
};

export const fetchTestResult = async (id) => {
  try {
    const response = await api.get(`/results/test-result/${id}`, {requiresAuth: true});
    return response.data;
  } catch (error) {
    console.error('Error fetching latest test results:', error);
    throw error;
  }
};
